import React from "react";
import PropTypes from "prop-types";
import FieldController from "components/FieldController";
import TextareaController from "components/TextareaController";
import { string as yupString, object as yupObject } from "yup";
import { useScrollToElement } from "utils/hooks/editor";

const BannerBlock = ({ name }) => {
  const rootPath = `${name}.data`;
  useScrollToElement(name);

  return (
    <div className="ph3">
      <div className="pt3">
        <FieldController
          name="title"
          key={`${rootPath}.title`}
          label="Name"
          rootPath={rootPath}
          fieldKey="title"
          validationSchema={yupObject().shape({
            title: yupString().required("Banner must have a title")
          })}
        />
      </div>
      <div className="pt3">
        <TextareaController
          key={`${rootPath}.subtitle`}
          name="subtitle"
          label="Subtitle"
          rootPath={rootPath}
          fieldKey="subtitle"
        />
      </div>
    </div>
  );
};

BannerBlock.propTypes = {
  name: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired,
  uid: PropTypes.string.isRequired,
  component: PropTypes.string.isRequired,
  schema: PropTypes.object.isRequired
};

export default BannerBlock;
